import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
//Components
import { Link } from "../../../atoms";
import {
  Section,
  SectionHeader,
  VerticalList,
  ListItem,
  Error,
  ContentContainer,
  ContentLoading,
  Text,
  Picture
} from "@uaveiro/ui";
import { withTheme } from "styled-components";

const ProjectList = ({ className, theme, loading, hasError, data }) => {
  const [showLogos, setShowLogos] = useState(true);

  const onHandleLogosError = e => {
    setShowLogos(false);
  };
  return (
    <Section
      className={className}
      paddingTop="70px"
      paddingBottom={showLogos ? "0" : "70px"}
      hasHighContrastBorderTop={false}
    >
      {loading ? (
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0">
              <ContentLoading />
            </div>
          </div>
        </div>
      ) : hasError ? (
        <Error />
      ) : (
        <Fragment>
          <div className="container">
            <div className="row no-gutters">
              <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0">
                <SectionHeader
                  hasContainer={false}
                  hasLink={false}
                  hasLine={false}
                  textColor={
                    theme.components.projects.projectDetails.titleColor
                  }
                >
                  {data.title.value}
                </SectionHeader>

                <VerticalList>
                  {data.fields.map((item, i) => {
                    let isMoney = item.type === "money";
                    let isLink = item.type === "link";
                    let isDate = item.type === "date";

                    const moneyValue =
                      isMoney &&
                      Number(item.info.value)
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,");

                    return (
                      item.info.value && (
                        <ListItem key={i} marginBottom="30px">
                          <Text
                            size="article"
                            color={
                              theme.components.projects.projectDetails.textColor
                            }
                          >
                            {item.info.label}
                          </Text>
                          {isLink ? (
                            <Link
                              href={item.extra}
                              fontWeight="300"
                              textDecoration="underline"
                              fontSize="15px"
                            >
                              {item.info.value}
                            </Link>
                          ) : (
                            <Text size="article">
                              {isDate
                                ? item.info.value.split(" ")[0]
                                : isMoney
                                ? moneyValue
                                : item.info.value}
                              {isMoney && "€"}
                            </Text>
                          )}
                        </ListItem>
                      )
                    );
                  })}
                </VerticalList>
              </div>
            </div>
          </div>

          {showLogos && (
            <ContentContainer
              borderTop={`1px solid ${theme.components.projects.projectDetails.logos.borderColor}`}
              padding="45px 0"
              marginTop="50px"
            >
              <div className="container">
                <div className="row no-gutters">
                  <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0">
                    <Picture
                      src={data.logos}
                      isLocal={false}
                      maxHeight="40px"
                      backgroundSize="contain"
                      imagePosition="left"
                      hasImageBgColor={false}
                      onCatchError={onHandleLogosError}
                    />
                  </div>
                </div>
              </div>
            </ContentContainer>
          )}
        </Fragment>
      )}
    </Section>
  );
};

ProjectList.propTypes = {
  className: PropTypes.string
};

export default withTheme(ProjectList);
